import axios from "axios";

export const euroRateMixin = {
  data() {
    return {
      euroRate: null,
    };
  },
  created() {
    this.fetchEuroRate();
  },
  methods: {
    async fetchEuroRate() {
      try {
        const response = await axios.get("https://api.feribot-eurobac.ro/api/euro-rate/");
        this.euroRate = response.data.rate || 1;
      } catch (error) {
        console.error("Eroare la preluarea cursului euro:", error);
        this.euroRate = 1; // Fallback în caz de eroare
      }
    },
  },
};
